import { render, staticRenderFns } from "./jbxxxq.vue?vue&type=template&id=21314ba4&scoped=true&"
import script from "./jbxxxq.vue?vue&type=script&lang=js&"
export * from "./jbxxxq.vue?vue&type=script&lang=js&"
import style0 from "./jbxxxq.vue?vue&type=style&index=0&id=21314ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21314ba4",
  null
  
)

export default component.exports